import type { ReactNode } from 'react';
import { Text } from '@components/base/display';
import { VStack, HStack } from '@components/base/layout';

interface SizeVariantEntry {
  size: string;
  dimension: string;
  description: string;
  renderComponent: () => ReactNode;
}

/**
 * Renders a grid of component size variants with labels and descriptions.
 * Shared across Avatar and Icon showcases to avoid CPD duplication.
 */
export function SizeVariantsGrid({ entries }: Readonly<{ entries: readonly SizeVariantEntry[] }>) {
  return (
    <VStack gap={4}>
      {entries.map((entry) => (
        <HStack key={entry.size} gap={4} align="center">
          <Text size="sm" color="muted" className="w-32 flex-shrink-0">
            {entry.size} ({entry.dimension})
          </Text>
          {entry.renderComponent()}
          <Text size="sm" color="secondary">
            {entry.description}
          </Text>
        </HStack>
      ))}
    </VStack>
  );
}
